let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cMgMB")).then(() => parcelRequire('4O160'));